import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bulma/css/bulma.min.css';
import './styles/custom-bulma.css'
// CFCM brand: loaded last so it wins over Bulma and App.css.
import './styles/brand.css';
import { installSharedRequests } from './utils/shareRequests';

// The same call to the API is not sent twice at the same moment (see utils/shareRequests.js).
installSharedRequests();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
